import { PopupMenu } from "components/menus/PopupMenu";
import { IMenuItem } from "./types";

import { ReactComponent as LinkIcon } from "components/icons/link.svg";
import { ReactComponent as EmbedIcon } from "components/icons/embed.svg";
import { ReactComponent as RedditIcon } from "components/icons/reddit_desktop.svg";
import { ReactComponent as TwitterIcon } from "components/icons/twitter_desktop.svg";
import { ReactComponent as DiscordIcon } from "components/icons/discord_desktop.svg";

import "./ShareGifMenu.scss";

const MENU_ITEMS = [
  {
    text: undefined,
    items: [
      {
        icon: <LinkIcon className="link" />,
        label: "Copy link",
        id: "link",
      },
      {
        icon: <EmbedIcon className="embed" />,
        label: "Embed",
        id: "embed",
      },
    ],
  },
  {
    text: "Social share:",
    items: [
      {
        icon: <RedditIcon />,
        label: "Reddit",
        className: "reddit",
        id: "reddit",
      },
      {
        icon: <TwitterIcon />,
        label: "Twitter",
        className: "twitter",
        id: "twitter",
      },
      {
        icon: <DiscordIcon />,
        label: "Discord",
        className: "discord",
        id: "discord",
      },
    ]
  },
];

export const ShareGifMenu = (props: {
  onClick: (item: IMenuItem) => void;
  onClose: () => void;
}): JSX.Element => {
  return <PopupMenu
    className="shareGifMenu"
    onClick={props.onClick}
    onClose={props.onClose}
    groups={MENU_ITEMS}
  />;
};
